  import React, { useState, useRef } from "react";
  import { motion } from "framer-motion";
  import { HeartHandshake, Leaf, Sparkles, Instagram, Mail, Phone, MapPin, ChevronRight, PawPrint, Feather, Waves } from "lucide-react";
  const sections = [
    { id: "accueil", label: "Accueil" },
    { id: "vision", label: "Ma Vision" },
    { id: "travail", label: "Travailler avec moi" },
    { id: "tarifs", label: "Tarifs" },
    { id: "contact", label: "Contact" },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.08 } },
  };

  const item = {
    hidden: { opacity: 0, y: 10 },
    show: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 70 } },
  };

  const Card = ({ children, className }) => (
    <div className={`rounded-2xl border border-[#5B3A29]/10 bg-white p-4 ${className}`}>
      {children}
    </div>
  );

  const CardHeader = ({ children, className }) => (
    <div className={`mb-3 ${className}`}>{children}</div>
  );

  const CardTitle = ({ children, className }) => (
    <h3 className={`text-lg font-semibold text-[#5B3A29] ${className}`}>{children}</h3>
  );

  const CardContent = ({ children, className }) => (
    <div className={`text-sm leading-relaxed ${className}`}>{children}</div>
  );

  const Button = ({ children, className, ...props }) => (
    <button className={`rounded-2xl px-4 py-2 font-semibold ${className}`} {...props}>
      {children}
    </button>
  );
  export default function SiteEderra() {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLinkClick = () => setMobileMenuOpen(false);
  const formRef = useRef(null);
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault(); // empêche le rechargement de la page

    try {
      const response = await fetch("/sendmail.php", {
        method: "POST",
        body: new FormData(formRef.current),
      });

      const result = await response.json();

      if (result.status === "success") {
        setStatus("Message envoyé avec succès 🎉");
        formRef.current.reset(); // vide le formulaire
      } else {
        setStatus("Erreur lors de l'envoi ❌");
      }
    } catch (error) {
      setStatus("Erreur serveur ❌");
    }
  };

  return (
    <div className="min-h-screen scroll-smooth bg-[#F6EFE7] text-[#3E2723]">
      {/* Top bar */}
      <div className="w-full bg-[#5B3A29] text-white text-sm py-2 px-4 flex items-center justify-between">
        <span className="font-medium tracking-wide">EDERRA · Bien-être corps & cœur</span>
        <div className="flex items-center gap-4">
          <a href="tel:+33672799107" className="inline-flex items-center gap-2 hover:opacity-90">
            <Phone className="w-4 h-4" />06 72 79 91 07
          </a>
          <a href="mailto:jehannocarole@gmail.com" className="inline-flex items-center gap-2 hover:opacity-90">
            <Mail className="w-4 h-4" />Email
          </a>
        </div>
      </div>

      {/* Nav */}
      <header className="sticky top-0 z-40 backdrop-blur bg-white/70 border-b border-[#5B3A29]/10">
        <nav className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
          <a href="#accueil" className="flex items-center gap-2">
            <img src="/logo.png" alt="Logo Ederra" className="h-20 w-20 object-contain" />
            <div className="leading-snug">
              <p className="font-semibold tracking-wide text-[#5B3A29] text-lg">EDERRA</p>
              <p className="text-sm text-[#5B3A29]/70">Carole Jehanno</p>
            </div>
          </a>

          {/* Menu desktop */}
          <ul className="hidden md:flex items-center gap-8 font-medium text-base">
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`} className="hover:text-[#5B3A29]">
                  {s.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Bouton RDV desktop */}
          <div className="hidden md:block">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 rounded-2xl px-5 py-3 text-base font-semibold bg-[#C8A045] text-white shadow hover:translate-y-[-1px] transition-transform"
            >
              Prendre RDV <ChevronRight className="w-5 h-5" />
            </a>
          </div>

          {/* Hamburger mobile */}
          <button
            className="md:hidden p-2 rounded-md border border-[#5B3A29]/30"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Ouvrir le menu</span>
            <div className="w-6 h-0.5 bg-[#5B3A29] mb-1" />
            <div className="w-6 h-0.5 bg-[#5B3A29] mb-1" />
            <div className="w-6 h-0.5 bg-[#5B3A29]" />
          </button>
        </nav>

        {/* Menu mobile overlay */}
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden bg-white border-t border-[#5B3A29]/10 shadow-lg"
          >
            <ul className="flex flex-col gap-4 p-4 font-medium text-base">
              {sections.map((s) => (
                <li key={s.id}>
                  <a
                    href={`#${s.id}`}
                    onClick={handleLinkClick}
                    className="block hover:text-[#5B3A29]"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#contact"
                  onClick={handleLinkClick}
                  className="inline-flex items-center gap-2 rounded-2xl px-5 py-3 font-semibold bg-[#C8A045] text-white shadow"
                >
                  Prendre RDV <ChevronRight className="w-5 h-5" />
                </a>
              </li>
            </ul>
          </motion.div>
        )}
      </header>

        {/* Hero */}
        <section id="accueil" className="relative overflow-hidden scroll-mt-24">
          <div className="absolute inset-0 opacity-10 pointer-events-none" aria-hidden>
            <svg className="w-full h-full" viewBox="0 0 800 400" preserveAspectRatio="none">
              <defs>
                <linearGradient id="g" x1="0" x2="1">
                  <stop offset="0%" stopColor="#C8A045" />
                  <stop offset="100%" stopColor="#5B3A29" />
                </linearGradient>
              </defs>
              <path d="M0,300 C200,250 300,350 500,300 C650,260 700,310 800,290 L800,400 L0,400 Z" fill="url(#g)" />
            </svg>
          </div>
          <div className="mx-auto max-w-6xl px-4 py-16 md:py-24">
            <motion.div variants={container} initial="hidden" animate="show" className="grid md:grid-cols-2 gap-10 items-center">
              <motion.div variants={item}>
                <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight text-[#5B3A29]">Ici on prend soin du corps et du cœur.</h1>
                <p className="mt-5 text-lg leading-relaxed max-w-prose">
                  Moi c’est <span className="font-semibold">Carole</span>, passionnée par les animaux et la compréhension du vivant. Entrepreneure depuis 2020, ma mission est d’accompagner les animaux et les humains vers un bien‑être physique & mental.
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a href="#travail" className="inline-flex items-center gap-2 rounded-2xl px-5 py-2.5 font-semibold bg-[#C8A045] text-white shadow hover:translate-y-[-1px] transition-transform">Découvrir mes accompagnements</a>
                  <a href="#contact" className="inline-flex items-center gap-2 rounded-2xl px-5 py-2.5 font-semibold border border-[#5B3A29]/20 bg-white">Me contacter</a>
                </div>
              </motion.div>
              <motion.div variants={item} className="relative">
  <div className="aspect-[4/3] w-full rounded-3xl bg-white shadow-xl border border-[#5B3A29]/10 grid place-items-center p-6">
    <img
      src="/carole+cheval.jpeg"
      alt="Carole et son cheval"
      className="w-full h-full object-cover rounded-3xl"
    />
  </div>
</motion.div>
            </motion.div>
          </div>
        </section>

        {/* Vision */}
        <section id="vision" className="mx-auto max-w-6xl px-4 py-20 scroll-mt-24">
          <motion.div initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true, amount:0.3}} transition={{duration:0.6}}>
            <h2 className="text-2xl md:text-4xl font-extrabold text-[#5B3A29]">Ma Vision en 3 piliers</h2>
            <p className="mt-3 max-w-prose">Prendre soin du vivant, au‑delà du corps : une approche globale qui relie physique, émotions et énergie.</p>
            <div className="mt-10 grid md:grid-cols-3 gap-6">
              <Card className="rounded-2xl border-[#5B3A29]/10 bg-white">
                <CardHeader className="space-y-2">
                  <div className="w-10 h-10 rounded-2xl bg-[#5B3A29] text-white grid place-items-center"><Leaf className="w-5 h-5"/></div>
                  <CardTitle className="text-[#5B3A29]">Approche Corporelle</CardTitle>
                </CardHeader>
                <CardContent className="text-sm leading-relaxed">
                  Passionnée et formée : l’anatomie, la biologie et la biomécanique sont indispensables dans mes prises en charge. Cela m’apporte précision et connaissances.
                </CardContent>
              </Card>
              <Card className="rounded-2xl border-[#5B3A29]/10 bg-white">
                <CardHeader className="space-y-2">
                  <div className="w-10 h-10 rounded-2xl bg-[#C8A045] text-white grid place-items-center"><HeartHandshake className="w-5 h-5"/></div>
                  <CardTitle className="text-[#5B3A29]">Approche Émotionnelle</CardTitle>
                </CardHeader>
                <CardContent className="text-sm leading-relaxed">
                  Derrière une tension ou un blocage du corps se cache souvent une émotion enfouie et non exprimée qui a besoin d’être écoutée et libérée.
                </CardContent>
              </Card>
              <Card className="rounded-2xl border-[#5B3A29]/10 bg-white">
                <CardHeader className="space-y-2">
                  <div className="w-10 h-10 rounded-2xl bg-[#5B3A29] text-white grid place-items-center"><Sparkles className="w-5 h-5"/></div>
                  <CardTitle className="text-[#5B3A29]">Approche Énergétique</CardTitle>
                </CardHeader>
                <CardContent className="text-sm leading-relaxed">
                  Le corps, les émotions : tout est vibration. Une vision spirituelle me permet de prendre en charge mes patients dans une large globalité.
                </CardContent>
              </Card>
            </div>
          </motion.div>
        </section>

        {/* Travailler avec moi */}
        <section id="travail" className="bg-white border-y border-[#5B3A29]/10 scroll-mt-24">
          <div className="mx-auto max-w-6xl px-4 py-20">
            <h2 className="text-2xl md:text-4xl font-extrabold text-[#5B3A29]">Travailler avec moi</h2>
            <div className="mt-10 grid lg:grid-cols-3 gap-6">
              <Card className="rounded-2xl border-[#5B3A29]/10">
                <CardHeader>
                  <CardTitle className="flex items-center gap-3"><PawPrint className="w-5 h-5 text-[#C8A045]"/>Séances Animaux</CardTitle>
                </CardHeader>
                <CardContent className="text-sm leading-relaxed space-y-3">
                  <p><strong>Harmonisation physique & émotionnelle</strong></p>
                  <p>Libération des tensions et blocages physiques via thérapie manuelle, prise en charge de l’état émotionnel et énergétique de votre animal.</p>
                  <p>Chaque séance est unique et adaptée à chacun.</p>
                </CardContent>
              </Card>

              <Card className="rounded-2xl border-[#5B3A29]/10">
                <CardHeader>
                  <CardTitle className="flex items-center gap-3"><HeartHandshake className="w-5 h-5 text-[#C8A045]"/>Séances Humains</CardTitle>
                </CardHeader>
                <CardContent className="text-sm leading-relaxed space-y-3">
                  <p><strong>Séance somato‑émotionnelle & énergétique</strong></p>
                  <p>Écoute et prise de conscience à travers un échange. Libération émotionnelle et énergétique grâce à un soin.</p>
                </CardContent>
              </Card>

              <Card className="rounded-2xl border-[#5B3A29]/10">
                <CardHeader>
                  <CardTitle className="flex items-center gap-3"><Feather className="w-5 h-5 text-[#C8A045]"/>Ateliers · Stages · Formations</CardTitle>
                </CardHeader>
                <CardContent className="text-sm leading-relaxed space-y-3">
                  <p><strong>Vous apporter les connaissances d’une autre manière. </strong></p>
                    <p>Seule ou associée à d’autres professionnelles, je propose régulièrement des ateliers, stages ou formations dans le domaine canin, équin ou développement personnel.</p>
                  <p>Retrouvez toutes les dates sur Instagram.</p>
                </CardContent>
              </Card>
            </div>

            {/* Diplômes */}
            <div className="mt-12">
              <h3 className="text-lg font-bold text-[#5B3A29]">Être bien formée pour bien vous accompagner</h3>
              <ul className="mt-4 grid md:grid-cols-2 gap-2 text-sm">
                <li>• Diplôme d’Ostéopathe Animalier — 2020</li>
                <li>• Reconnue par l'Ordre National des Vétérinaires OA578</li>
                <li>• Thérapeute Somato‑Émotionnel — 2023</li>
                <li>• Praticienne soin énergétique Bioénergie — 2023</li>
                <li>• Praticienne Technique Neuro‑Cutanée — 2024</li>
                <li>• Et un besoin de connaissances infinies (livres, podcasts, webinaires…)</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Tarifs */}
        <section id="tarifs" className="mx-auto max-w-6xl px-4 py-20 scroll-mt-24">
  <h2 className="text-2xl md:text-4xl font-extrabold text-[#5B3A29]">Tarifs</h2>

  <div className="mt-10 grid md:grid-cols-2 gap-6">
    {/* Séances Animaux */}
    <Card className="rounded-2xl border border-[#5B3A29]/10">
      <CardHeader>
        <CardTitle className="flex items-center gap-3">
          <PawPrint className="w-5 h-5 text-[#C8A045]" />
          Séance Animaux
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm leading-relaxed space-y-3">
        <div className="grid grid-cols-2 gap-2">
          <div className="p-3 rounded-xl bg-[#F6EFE7] border border-[#5B3A29]/10 flex justify-between items-center">
            <span>Chiens / Chats*</span>
            <span className="font-semibold">60€</span>
          </div>
          <div className="p-3 rounded-xl bg-[#F6EFE7] border border-[#5B3A29]/10 flex justify-between items-center">
            <span>NACS*</span>
            <span className="font-semibold">45€</span>
          </div>
          <div className="p-3 rounded-xl bg-[#F6EFE7] border border-[#5B3A29]/10 flex justify-between items-center col-span-2">
            <span>Chevaux</span>
            <span className="font-semibold">90€</span>
          </div>
        </div>
        <p className="text-xs text-[#3E2723]/70">* Les séances ont lieu au cabinet.</p>
      </CardContent>
    </Card>

    {/* Séances Humains */}
    <Card className="rounded-2xl border border-[#5B3A29]/10">
      <CardHeader>
        <CardTitle className="flex items-center gap-3">
          <HeartHandshake className="w-5 h-5 text-[#C8A045]" />
          Séance Humains
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm leading-relaxed space-y-3">
        <div className="space-y-2">
          <div className="p-3 rounded-xl bg-[#F6EFE7] border border-[#5B3A29]/10 flex justify-between items-center">
            <span>Séance complète — Temps d’échange + Soin somato-émotionnel & énergétique</span>
            <span className="font-semibold pr-4">90€</span>
          </div>
          <div className="p-3 rounded-xl bg-[#F6EFE7] border border-[#5B3A29]/10 flex justify-between items-center">
            <span>Séance suivi — Temps d’échange uniquement après une séance complète</span>
            <span className="font-semibold pr-4">60€</span>
          </div>
        </div>

        <div className="space-y-2">
          <div className="p-3 rounded-xl bg-white border border-[#C8A045]/30 flex justify-between items-center">
            <span>Accompagnement 6 semaines</span>
            <span className="font-semibold pr-4">270€</span>
          </div>
          <div className="p-3 rounded-xl bg-white border border-[#C8A045]/30 flex justify-between items-center">
            <span>Accompagnement 3 mois</span>
            <span className="font-semibold pr-4">320€</span>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
</section>

        {/* Partenaires */}
        <section className="bg-white border-y border-[#5B3A29]/10 scroll-mt-24">
  <div className="mx-auto max-w-6xl px-4 py-16">
    <h3 className="text-lg font-bold text-[#5B3A29]">Mes partenaires</h3>
    <ul className="mt-6 grid md:grid-cols-2 gap-3 text-sm leading-relaxed">
      
      <li>
        <a 
          href="https://www.instagram.com/lecoledebin?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" 
          target="_blank" 
          rel="noreferrer" 
          className="flex items-center gap-2 hover:text-[#C8A045] transition-colors"
        >
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          L’école d’Ebin — Adelyne Vuillemin : éducation canine
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/kinesiologie_rcs?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          Vanessa Mulot : podologue équin, kinésiologie, réflexologie cranio-sacrée
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/tde_gwen?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          Gwenaëlle Delage : technicien dentaire équin
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/_pat.parazzi_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          Pat’Parazzi — Léonie Laniesse : photographe animalier
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/so.photographie_sb?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          So.Photographie — Sophie Barbedor : photographe animalier
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/morgane_and_compagnie35?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          Morgane & Compagnie — Morgane Lepage : Pet Sitting
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/letiki.et.compagnie?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          Léti Ki : Hôtel Canin
        </a>
      </li>

      <li>
        <a href="https://www.instagram.com/lea.t_canin_equin?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#C8A045]">
          <img src="/instagram.svg" alt="Instagram" className="w-4 h-4" />
          Au relais des 4 pattes : Salon de toilettage
        </a>
      </li>

    </ul>
  </div>
</section>


        {/* Contact */}
        <section id="contact" className="mx-auto max-w-6xl px-4 py-20 scroll-mt-24">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-2xl md:text-4xl font-extrabold text-[#5B3A29]">Contact</h2>
              <div className="mt-6 space-y-3 text-sm">
                <p className="flex items-center gap-2"><Phone className="w-4 h-4"/> 06 72 79 91 07</p>
                <p className="flex items-center gap-2"><Mail className="w-4 h-4"/> jehannocarole@gmail.com</p>
                <p className="flex items-center gap-2"><MapPin className="w-4 h-4"/> 3 La Touche, 35360 La Chapelle du Lou du Lac</p>
                <p className="text-xs text-[#3E2723]/70">Secteurs couverts : 35, 22, 56</p>
                <div className="pt-3 flex items-center gap-3">
                  <a href="https://www.instagram.com/ederra__?igsh=YTFzdG5vZzEyMGZ6&utm_source=qr" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-2xl px-4 py-2 text-sm font-semibold bg-[#5B3A29] text-white shadow">Instagram</a>
                  <a href="https://www.tiktok.com/@ederra__?_t=ZN-8z7K9FlXhwM&_r=1" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-2xl px-4 py-2 text-sm font-semibold border border-[#5B3A29]/20 bg-white">TikTok</a>
                </div>
              </div>

              <form 
  ref={formRef}
  onSubmit={handleSubmit}
  className="mt-8 grid grid-cols-1 gap-3"
>
  <input 
    name="name" 
    className="rounded-2xl px-4 py-3 bg-white border border-[#5B3A29]/20" 
    placeholder="Nom" 
  />
  <div className="grid md:grid-cols-2 gap-3">
    <input 
      name="email" 
      className="rounded-2xl px-4 py-3 bg-white border border-[#5B3A29]/20" 
      placeholder="Email" 
    />
    <input 
      name="phone" 
      className="rounded-2xl px-4 py-3 bg-white border border-[#5B3A29]/20" 
      placeholder="Téléphone" 
    />
  </div>
  <textarea 
    name="message" 
    rows={5} 
    className="rounded-2xl px-4 py-3 bg-white border border-[#5B3A29]/20" 
    placeholder="Votre message" 
  />
  <Button 
    type="submit" 
    className="rounded-2xl bg-[#C8A045] text-white px-5 py-2.5 font-semibold w-fit"
  >
    Envoyer
  </Button>

  {status && (
    <p className="mt-3 text-sm text-center text-gray-700">{status}</p>
  )}
</form>

            </div>

            <div className="rounded-3xl overflow-hidden border border-[#5B3A29]/10 shadow bg-[#F6EFE7]">
    <div className="w-full h-full flex items-center justify-center">
    <img 
      src="/trio.jpg" 
      alt="Présentation trio" 
      className="max-h-full w-auto object-contain"
    />
  </div>
  </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-10 bg-[#5B3A29] text-white">
          <div className="mx-auto max-w-6xl px-4 py-10 grid md:grid-cols-3 gap-8">
            <div>
              <p className="font-semibold">EDERRA — Carole Jehanno</p>
              <p className="text-sm mt-2 text-white/80">Ici on prend soin du corps et du cœur.</p>
            </div>
            <div>
              <p className="font-semibold">Navigation</p>
              <ul className="text-sm mt-2 space-y-1 text-white/80">
                {sections.map(s => (
                  <li key={s.id}><a href={`#${s.id}`}>{s.label}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-semibold">Mentions</p>
              <ul className="text-sm mt-2 space-y-1 text-white/80">
                <li>SIRET — 894 319 805 000 12
</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10">
            <div className="mx-auto max-w-6xl px-4 py-4 text-xs text-white/70 flex items-center justify-between">
              <span>© {new Date().getFullYear()} EDERRA. Tous droits réservés.</span>
            </div>
          </div>
        </footer>
      </div>
    );
  }
